import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

// El dashboard SBC vive en un iframe (public/sbc-dashboard.html). Su sidebar
// interno está oculto; la navegación de secciones (clientes/debug/firewall/
// estadisticas) llega desde el submenú del panel principal:
//  - el hash inicial (#seccion) fija la sección al cargar el iframe,
//  - luego cada cambio de submenú se envía por postMessage SIN recargar.
export default function KamaIoSBC() {
  const { tab } = useParams();
  const active = tab || 'clientes';
  const ref = useRef(null);
  // src fijo (solo el hash inicial) para que cambiar de sección NO recargue el iframe.
  // ?v=… es cache-busting: subir el número cuando se cambie sbc-dashboard.html fuerza
  // al navegador a traer la versión nueva sin depender de un hard-refresh del iframe.
  const initialSrc = useRef(`/sbc-dashboard.html?v=4#${active}`).current;

  const post = () => {
    try { ref.current?.contentWindow?.postMessage({ type: 'sbc-tab', tab: active }, '*'); }
    catch (e) { /* iframe aún no listo */ }
  };

  useEffect(() => { post(); }, [active]);

  return (
    <div style={{ width: '100%', height: 'calc(100vh - 88px)', overflow: 'hidden' }}>
      <iframe
        ref={ref}
        src={initialSrc}
        onLoad={post}
        style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
        title="Kamailio SBC Dashboard"
        allow="camera; microphone"
      />
    </div>
  );
}
